import "../css/main";

const main = async () => {
  // enable transitions
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      document.body.classList.add("transitions-enabled");
    });
  });
};

main();
